import { App } from "vue";

import { CustomDate } from "@/shared/domain/classes/custom-date";
import { DataFormatterUtil } from "../../../src/shared/application/utils/data-formatter-util";

export default {
	install: (app: App, options?: any): void => {
		app.config.globalProperties.$is_number = (var_to_check: any): boolean => {
			return DataFormatterUtil.is_number(var_to_check);
		};

		app.config.globalProperties.$is_string = (var_to_check: any): boolean => {
			return DataFormatterUtil.is_string(var_to_check);
		};

		app.config.globalProperties.$is_function = (var_to_check: any): boolean => {
			return DataFormatterUtil.is_function(var_to_check);
		};

		app.config.globalProperties.$is_date = (var_to_check: any): boolean => {
			return DataFormatterUtil.is_date(var_to_check);
		};

		app.config.globalProperties.$format_number = (
			number_to_format: any,
			decimals: number | null = null,
			hide_thousands_separator: boolean = false
		): string | null => {
			return DataFormatterUtil.format_number(
				number_to_format,
				decimals,
				hide_thousands_separator
			);
		};

		app.config.globalProperties.$parse_to_number = (
			string_number: string
		): number | null => {
			return DataFormatterUtil.parse_to_number(string_number);
		};

		app.config.globalProperties.$format_date_to_day = (
			date: Date | string | CustomDate
		): string => {
			return DataFormatterUtil.format_date_to_day(date);
		};

		app.config.globalProperties.$format_date_to_day_number = (
			date: Date | string | CustomDate
		): string => {
			return DataFormatterUtil.format_date_to_day_number(date);
		};

		app.config.globalProperties.$format_date_to_month = (
			date: Date | string | CustomDate
		): string => {
			return DataFormatterUtil.format_date_to_month(date);
		};

		app.config.globalProperties.$format_date_to_month_string = (
			date: Date | string | CustomDate
		): string => {
			return DataFormatterUtil.format_date_to_month_string(date);
		};

		app.config.globalProperties.$format_date_to_month_abbreviated_string = (
			date: Date | string | CustomDate
		): string => {
			return DataFormatterUtil.format_date_to_month_abbreviated_string(date);
		};

		app.config.globalProperties.$format_date_to_month_number = (
			date: Date | string | CustomDate
		): number => {
			return DataFormatterUtil.format_date_to_month_number(date);
		};

		app.config.globalProperties.$format_date_to_month_day_number = (
			date: Date | string | CustomDate
		): number => {
			return DataFormatterUtil.format_date_to_month_day_number(date);
		};

		app.config.globalProperties.$format_date_to_year_number = (
			date: Date | string | CustomDate
		): number => {
			return DataFormatterUtil.format_date_to_year_number(date);
		};

		app.config.globalProperties.$format_date_to_day_hour_minute = (
			date: Date | string | CustomDate
		): string => {
			return DataFormatterUtil.format_date_to_day_hour_minute(date);
		};

		app.config.globalProperties.$format_date_to_hour_minute = (
			date: Date | string | CustomDate
		): string => {
			return DataFormatterUtil.format_date_to_hour_minute(date);
		};

		app.config.globalProperties.$get_object_value_from_path = (
			object: any,
			path: string
		): any => {
			return DataFormatterUtil.get_object_value_from_path(object, path);
		};
	}
};

declare module "@vue/runtime-core" {
	interface ComponentCustomProperties {
		$is_number: (var_to_check: any) => boolean;
		$is_string: (var_to_check: any) => boolean;
		$is_function: (var_to_check: any) => boolean;
		$is_date: (var_to_check: any) => boolean;
		$format_number: (
			number_to_format: any,
			decimals?: number | null,
			hide_thousands_separator?: boolean
		) => string | null;
		$parse_to_number: (string_number: string) => number | null;
		$format_date_to_day: (date: Date | string | CustomDate) => string;
		$format_date_to_day_number: (date: Date | string | CustomDate) => string;
		$format_date_to_month: (date: Date | string | CustomDate) => string;
		$format_date_to_month_string: (date: Date | string | CustomDate) => string;
		$format_date_to_month_abbreviated_string: (
			date: Date | string | CustomDate
		) => string;
		$format_date_to_month_number: (date: Date | string | CustomDate) => number;
		$format_date_to_month_day_number: (
			date: Date | string | CustomDate
		) => number;
		$format_date_to_year_number: (date: Date | string | CustomDate) => number;
		$format_date_to_day_hour_minute: (
			date: Date | string | CustomDate
		) => string;
		$format_date_to_hour_minute: (date: Date | string | CustomDate) => string;
		$get_object_value_from_path: (object: any, path: string) => any;
	}
}
